import { MessagePanel } from 'view-layer/components/layout';
import { useDocumentTitle } from 'business-layer/hooks/useDocumentTitle';

export const NotFound = (props: any) => {
  useDocumentTitle('Page Not Found');
  return (
      <MessagePanel
        type="error"
        title="Error 404"
        message="The page you are looking for cannot be found"
      />
  )
}
